const getClassrooms = (classrooms = []) => {
  const options = classrooms.map(item => ({
    value: item.id || '',
    label: item.name || ''
  }));

  return options;
};

const getGroups = (classId = '', classrooms = [], i18n) => {
  let classroom = classrooms.find(classItem => classItem.id === Number(classId));
  if (!classroom) classroom = classrooms[0];
  if (classroom && classroom.groups && classroom.groups instanceof Array) {
    const options = classroom.groups.sort((a, b) => {
      if (a.name.startsWith('Default Group')) return -1;
      if (b.name.startsWith('Default Group')) return 1;

      return a.name.localeCompare(b.name);
    }).map(item => ({
      value: item.id,
      label: item.name
    }));

    options.unshift({ value: '-1', label: i18n.t`Whole class` });
    return options;
  } return [];
};

const getStudents = (classId, groupId, classrooms) => {
  const classroom = classrooms.find(c => c.id === classId);
  if (groupId === '-1') {
    const students = [];
    for (const group of classroom.groups) {
      for (const student of group.students) {
        const isStudentExists = students.find(s => s.id === student.id);
        if (!isStudentExists) {
          students.push(student);
        }
      }
    }
    return students;
  }

  const group = classroom.groups.find(g => g.id === groupId);
  return group.students;
};

const setDefaultValues = (isClass, classrooms) => {
  if (isClass) {
    return {
      value: classrooms[0].id,
      label: classrooms[0].name
    };
  }

  return {
    value: classrooms[0].groups[0].id,
    label: classrooms[0].groups[0].name
  };
};

const searchSelectedClass = (classrooms = [], classId = '') => {
  if ((classrooms instanceof Array) && classrooms.length) {
    const selectedClass = classrooms.find(classItem => classItem.id === Number(classId));
    if (selectedClass) return { value: selectedClass.id, label: selectedClass.name || '' };
  } return null;
};

const searchSelectedGroup = (classrooms = [], classId = '', groupId = '') => {
  let classroom = [];
  if ((classrooms instanceof Array)) {
    classroom = classrooms.find(classItem => classItem.id === Number(classId));
  }
  if (classroom && classroom.groups && classroom.groups instanceof Array) {
    const options = classroom.groups.find(groupItem => groupItem.id === Number(groupId));
    if (options) {
      return { value: options.id, label: options.name || '' };
    }
  }
  return null;
};

export { getClassrooms, getGroups, getStudents, setDefaultValues, searchSelectedClass, searchSelectedGroup };
